import { Dispatch, SetStateAction } from "react";
import { useIntl } from "react-intl";
import { Select } from "semantic-ui-react";
import { TranslateProps } from "../../../i18n/TranslateProps";
import {
    AuthorizationType,
    authorizationTypeOptions,
    IAuthorization,
    newAuthorizationInit,
} from "../../../models/authorization";
import { CertificateType, ICertificate } from "../../../models/certificate";
import { riverRangeProps } from "../../../models/common";

type Props = {
    certificate: ICertificate;
    setCertificate: Dispatch<SetStateAction<ICertificate>>;
};

export const AuthorizationsForm = ({ certificate, setCertificate }: Props) => {
    const intl = useIntl();

    const handleAddRiverRanges = (values: number[]) => {
        setCertificate({
            ...certificate,
            authorizations: certificate.authorizations.map(a => ({
                ...a,
                riverKilometers: a.type === AuthorizationType.S ? values : [],
            })),
        });
    };

    const handleSpecificAuthorizations = (types: number[]) => {
        // get all stretches from S type authorizations
        const strecthes = certificate.authorizations
            .map(x => x.riverKilometers)
            .flat()
            .filter((value, index, array) => array.indexOf(value) === index); // remove duplicate stretches

        const newAuths: IAuthorization[] = [];
        types.forEach(t =>
            newAuths.push({
                ...newAuthorizationInit,
                type: t as AuthorizationType,
                linkedCertificateGuid: certificate.guid,
                startDate: certificate.startDate,
                endDate: certificate.endDate,
                issuingAuthority: certificate.issuingAuthority,
                status: certificate.status,
                linkedQualificationID: certificate.qualificationID,
                crewMemberGuid: certificate.crewMemberGuid,
                riverKilometers: t === AuthorizationType.S ? strecthes : [],
            })
        );
        setCertificate({ ...certificate, authorizations: newAuths });
    };

    return (
        <>
            <section className="input-container" style={{ paddingBottom: "10px" }}>
                <label>{intl.formatMessage({ id: "specificAuthorizations" })}</label>
                <Select
                    search
                    multiple
                    options={TranslateProps(authorizationTypeOptions)}
                    value={Array.from(new Set(certificate.authorizations.map(item => item.type)))} // remove duplicate authorizations
                    onChange={(_e, data: any) => handleSpecificAuthorizations(data.value)}
                    disabled={certificate.type !== CertificateType.UcqBoatmaster}
                    closeOnChange
                />
            </section>
            <div className="certificate-row two">
                {certificate.authorizations.map(a => a.type).includes(AuthorizationType.S) && (
                    <section className="input-container">
                        <label>{intl.formatMessage({ id: "range" })}</label>
                        <Select
                            search
                            multiple
                            options={riverRangeProps}
                            value={
                                certificate.authorizations
                                    .map(x => x.riverKilometers)
                                    .flat()
                                    .filter(
                                        (value, index, array) => array.indexOf(value) === index
                                    ) ?? // remove duplicate stretches
                                []
                            }
                            onChange={(_e, data: any) => handleAddRiverRanges(data.value)}
                        />
                    </section>
                )}
            </div>
        </>
    );
};
